module.exports = __webpack_public_path__ + "img/icon_sportMenu_soccer.d322f41b.svg";